"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckboxRoot = exports.StyledCheckboxIndicator = exports.StyledIndicatorFocusRing = exports.StyledIndicatorOuterRing = exports.StyledIndicatorBackground = void 0;
const RadixCheckbox = __importStar(require("@radix-ui/react-checkbox"));
const styled_components_1 = __importStar(require("styled-components"));
const getCheckboxRootAppearance = ({ $appearance = "solid", }) => {
    if ($appearance === "solid") {
        return (0, styled_components_1.css) `
            padding: 0.5rem 0.75rem;

            border: 1px solid var(--ds-color-silver);
            border-radius: var(--ds-border-radius);
            background-color: var(--ds-color-white);

            transition:
                background-color 250ms ease,
                border-color 250ms ease;

            &:not([data-disabled]) {
                &:hover {
                    border-color: var(--ds-color-metal);
                }
            }
            &[data-state="checked"] {
                background-color: var(--ds-color-blue-10);
            }
            &[data-disabled] {
                background-color: var(--ds-color-cloud);
                border-color: var(--ds-color-silver);
            }
        `;
    }
    return null;
};
exports.StyledIndicatorBackground = styled_components_1.default.svg `
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
`;
exports.StyledIndicatorOuterRing = styled_components_1.default.rect `
    fill: var(--ds-color-white);
    stroke-width: 2px;
    stroke: var(--ds-color-stone);
    transition:
        fill 250ms ease,
        stroke 250ms ease,
        stroke-width 250ms ease;
`;
exports.StyledIndicatorFocusRing = styled_components_1.default.rect `
    fill: transparent;
    stroke-width: 0;
    stroke: var(--ds-color-blue-100);
    opacity: 0;
    transition:
        stroke 250ms ease,
        stroke-width 250ms ease,
        opacity 250ms ease;
`;
exports.StyledCheckboxIndicator = styled_components_1.default.div `
    position: relative;
    width: 1rem;
    height: 1rem;

    flex-shrink: 0;

    transform: translateY(0.25rem);

    .checkbox-icon {
        position: absolute;
        top: 50%;
        left: 50%;

        transform: translate(-50%, -50%);

        width: 1rem;
        height: 1rem;
    }
`;
exports.StyledCheckboxRoot = (0, styled_components_1.default)(RadixCheckbox.Root) `
    /* reset button defaults */
    all: unset;

    display: inline-flex;
    align-items: flex-start;
    gap: 0.5rem;

    flex-grow: 1;
    width: 100%;
    box-sizing: border-box;

    cursor: pointer;
    ${getCheckboxRootAppearance}

    label {
        cursor: inherit;
        color: var(--ds-color-night);
    }
    &[data-disabled] {
        cursor: not-allowed;

        label {
            color: var(--ds-color-stone);
        }
        ${exports.StyledIndicatorOuterRing} {
            fill: transparent;
            stroke-color: var(--ds-color-stone);
        }
    }
    &:not([data-disabled]):hover ${exports.StyledIndicatorOuterRing} {
        stroke: var(--ds-color-metal);
        stroke-width: 4px;
    }
    &:focus&:focus,
    &:focus-visible {
        /* Move the focus on the child (toggle) rather than wrapper (toggle+label) */
        outline: none;
        box-shadow: none;
        ${exports.StyledIndicatorFocusRing} {
            fill: var(--ds-color-white);
            stroke-width: 2px;
            opacity: 1;
        }
    }
    &[data-state="checked"] {
        &:not([data-disabled]):hover ${exports.StyledIndicatorOuterRing} {
            stroke: transparent;
            stroke-width: 0;
            fill: var(--ds-color-metal);
        }
        &:not([data-disabled]) ${exports.StyledIndicatorOuterRing} {
            stroke: transparent;
            stroke-width: 0;
            fill: var(--ds-color-blue-100);
        }
        &[data-disabled] ${exports.StyledIndicatorOuterRing} {
            stroke: transparent;
            stroke-width: 0;
            fill: var(--ds-color-stone);
        }
    }
`;
//# sourceMappingURL=Checkbox.styles.js.map